import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";
import { INDUSTRY_CARDS } from "../../data/site";

export default function Industries() {
  return (
    <MarketingLayout>
      <Seo title="Industries — AllToMAIDIt" description="Lead-to-Client systems for home services, contractors, real estate, professional services and small business." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
        <p className="eyebrow text-alto-red mb-3">Industries</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-4">Built for lead-driven businesses.</h1>
        <p className="text-neutral-400 max-w-2xl mb-14 text-sm sm:text-base">Every lead has real monetary value — so losing one is losing money. We tailor the Lead-to-Client System to how your industry actually captures and closes business.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRY_CARDS.map((c) => {
            const to = c.go ? `/go/${c.go}` : "/lead-system-audit";
            return (
              <Link key={c.slug} to={to} data-testid={`industry-card-${c.slug}`} className="card-hairline rounded-xl p-7 bg-alto-charcoal group">
                <c.icon className="text-alto-red mb-5" size={28} />
                <h2 className="font-display text-xl font-bold group-hover:text-alto-red transition-colors">{c.name}</h2>
                <p className="text-sm text-neutral-400 mt-2">{c.desc}</p>
                <span className="inline-flex items-center gap-2 text-alto-red text-sm font-semibold mt-5">{c.go ? "See the campaign" : "Get a free audit"} <ArrowRight size={15} /></span>
              </Link>
            );
          })}
        </div>
        <div className="mt-12 rounded-2xl p-8 bg-alto-panel border border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div><h2 className="font-display text-2xl font-bold">Don't see your industry?</h2><p className="text-neutral-400 mt-2 text-sm">If your business runs on leads, the system works. Start with a free audit.</p></div>
          <Link to="/lead-system-audit" className="btn-red font-bold px-6 py-3.5 rounded-md inline-flex items-center gap-2 text-sm shrink-0">GET A FREE AUDIT <ArrowRight size={16} /></Link>
        </div>
      </div>
    </MarketingLayout>
  );
}
